(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["raer-collection"] && !Shopify.designMode) return;
  try {
    
(() => {
  const mount = (scope = document) => {
    scope.querySelectorAll('[data-raer-catalogue-form]').forEach(form => {
      if (form.dataset.raerCatalogueReady) return;
      form.dataset.raerCatalogueReady = 'true';
      form.querySelectorAll('[data-raer-price-range]').forEach(range => {
        const min = range.querySelector('[data-price-min]');
        const max = range.querySelector('[data-price-max]');
        const validate = () => max.setCustomValidity(min.value !== '' && max.value !== '' && min.valueAsNumber > max.valueAsNumber ? form.dataset.rangeError : '');
        min.addEventListener('input', validate);
        max.addEventListener('input', validate);
        validate();
      });
      form.addEventListener('invalid', event => {
        const details = event.target.closest('details');
        if (details) details.open = true;
      }, true);
      form.addEventListener('formdata', event => {
        form.querySelectorAll('[data-price-min],[data-price-max]').forEach(input => {
          if (input.value === '') event.formData.delete(input.name);
        });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(), { once: true });
  else mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["raer-contact-editable"] && !Shopify.designMode) return;
  try {
    
(() => {
  window.raerContactController?.destroy();
  const lifetime = new AbortController();
  const instances = new Map();
  const storageKey = 'raer-contact-last-topic';
  const allowedTopics = ['conseil', 'commande', 'retour', 'professionnel'];
  const rememberTopic = (value) => { try { sessionStorage.setItem(storageKey, value); } catch {} };
  const mount = () => {
    document.querySelectorAll('[data-raer-contact]').forEach(root => {
      if (instances.has(root)) return;
      const controller = new AbortController();
      instances.set(root, controller);
      const signal = controller.signal;
      const subject = root.querySelector('[data-contact-subject]');
      const order = root.querySelector('[data-contact-order]');
      const orderInput = order?.querySelector('input');
      const status = root.querySelector('[data-contact-errors], [data-contact-success]');
      if (subject && root.querySelector('[data-contact-errors]')) {
        try {
          const previous = sessionStorage.getItem(storageKey);
          if (allowedTopics.includes(previous)) subject.value = previous;
        } catch {}
      }
      const syncOrder = () => {
        if (!subject || !order || !orderInput) return;
        const needed = ['commande', 'retour'].includes(subject.value);
        order.hidden = !needed;
        orderInput.disabled = !needed;
      };
      syncOrder();
      subject?.addEventListener('change', () => { syncOrder(); rememberTopic(subject.value); }, { signal });
      root.querySelector('form')?.addEventListener('submit', () => {
        if (subject) rememberTopic(subject.value);
      }, { signal });
      root.querySelectorAll('[data-contact-topic]').forEach(link => {
        link.addEventListener('click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          if (!subject) return;
          const nextTopic = link.dataset.contactTopic;
          if (!allowedTopics.includes(nextTopic)) return;
          event.preventDefault();
          subject.value = nextTopic;
          syncOrder();
          rememberTopic(nextTopic);
          const target = root.querySelector('#contact-form');
          const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
          target?.scrollIntoView({ behavior: reduce ? 'instant' : 'smooth', block: 'start' });
          (target?.querySelector('input') || subject).focus({ preventScroll: true });
        }, { signal });
      });
      if (status) {
        status.focus({ preventScroll: false });
        if (root.querySelector('[data-contact-success]')) {
          try { sessionStorage.removeItem(storageKey); } catch {}
        }
      }
    });
  };
  document.addEventListener('shopify:section:load', mount, { signal: lifetime.signal });
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, controller] of instances) {
      if (event.target.contains(root)) { controller.abort(); instances.delete(root); }
    }
  }, { signal: lifetime.signal });
  window.raerContactController = {
    destroy() {
      lifetime.abort();
      for (const controller of instances.values()) controller.abort();
      instances.clear();
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true, signal: lifetime.signal });
  else mount();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["raer-contact"] && !Shopify.designMode) return;
  try {
    
(() => {
  window.raerContactController?.destroy();
  const lifetime = new AbortController();
  const instances = new Map();
  const storageKey = 'raer-contact-last-topic';
  const allowedTopics = ['conseil', 'commande', 'retour', 'professionnel'];
  const rememberTopic = (value) => { try { sessionStorage.setItem(storageKey, value); } catch {} };
  const mount = () => {
    document.querySelectorAll('[data-raer-contact]').forEach(root => {
      if (instances.has(root)) return;
      const controller = new AbortController();
      instances.set(root, controller);
      const signal = controller.signal;
      const subject = root.querySelector('[data-contact-subject]');
      const order = root.querySelector('[data-contact-order]');
      const orderInput = order?.querySelector('input');
      const status = root.querySelector('[data-contact-errors], [data-contact-success]');
      if (subject && root.querySelector('[data-contact-errors]')) {
        try {
          const previous = sessionStorage.getItem(storageKey);
          if (allowedTopics.includes(previous)) subject.value = previous;
        } catch {}
      }
      const syncOrder = () => {
        if (!subject || !order || !orderInput) return;
        const needed = ['commande', 'retour'].includes(subject.value);
        order.hidden = !needed;
        orderInput.disabled = !needed;
      };
      syncOrder();
      subject?.addEventListener('change', () => { syncOrder(); rememberTopic(subject.value); }, { signal });
      root.querySelector('form')?.addEventListener('submit', () => {
        if (subject) rememberTopic(subject.value);
      }, { signal });
      root.querySelectorAll('[data-contact-topic]').forEach(link => {
        link.addEventListener('click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          if (!subject) return;
          const nextTopic = link.dataset.contactTopic;
          if (!allowedTopics.includes(nextTopic)) return;
          event.preventDefault();
          subject.value = nextTopic;
          syncOrder();
          rememberTopic(nextTopic);
          const target = root.querySelector('#contact-form');
          const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
          target?.scrollIntoView({ behavior: reduce ? 'instant' : 'smooth', block: 'start' });
          (target?.querySelector('input') || subject).focus({ preventScroll: true });
        }, { signal });
      });
      if (status) {
        status.focus({ preventScroll: false });
        if (root.querySelector('[data-contact-success]')) {
          try { sessionStorage.removeItem(storageKey); } catch {}
        }
      }
    });
  };
  document.addEventListener('shopify:section:load', mount, { signal: lifetime.signal });
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, controller] of instances) {
      if (event.target.contains(root)) { controller.abort(); instances.delete(root); }
    }
  }, { signal: lifetime.signal });
  window.raerContactController = {
    destroy() {
      lifetime.abort();
      for (const controller of instances.values()) controller.abort();
      instances.clear();
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true, signal: lifetime.signal });
  else mount();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["raer-home-editable"] && !Shopify.designMode) return;
  try {
    
function initRaerHome(root) {
  root.querySelectorAll('[data-raer-signature-size]').forEach((button) => {
    if (button.dataset.raerBound) return;
    button.dataset.raerBound = 'true';
    button.addEventListener('click', () => {
      const form = button.closest('form');
      form.querySelector('[data-raer-signature-variant]').value = button.dataset.variantId;
      const add = form.querySelector('[data-raer-signature-add]');
      add.disabled = false;
      add.textContent = 'Ajouter à la sélection';
      form.querySelectorAll('[data-raer-signature-size]').forEach((choice) => {
        const selected = choice === button;
        choice.classList.toggle('is-selected', selected);
        choice.setAttribute('aria-pressed', String(selected));
      });
    });
  });
  root.querySelectorAll('.product-section').forEach((section) => {
    const rail = section.querySelector('.product-rail');
    const actions = section.querySelector('.rail-actions');
    if (!rail || !actions || rail.dataset.raerBound) return;
    rail.dataset.raerBound = 'true';
    const buttons = actions.querySelectorAll('[data-raer-rail-direction]');
    const updateRailActions = () => {
      const maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
      actions.hidden = maxScroll <= 2;
      buttons.forEach((button) => {
        button.disabled = Number(button.dataset.raerRailDirection) < 0
          ? rail.scrollLeft <= 2
          : rail.scrollLeft >= maxScroll - 2;
      });
    };
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        rail.scrollBy({ left: Number(button.dataset.raerRailDirection) * rail.clientWidth * 0.72, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      });
    });
    rail.addEventListener('scroll', updateRailActions, { passive: true });
    const resizeObserver = new ResizeObserver(updateRailActions);
    resizeObserver.observe(rail);
    rail.querySelectorAll('.product-card').forEach((card) => resizeObserver.observe(card));
    const disconnectRailObserver = (event) => {
      if (event.target.contains(root)) {
        resizeObserver.disconnect();
        document.removeEventListener('shopify:section:unload', disconnectRailObserver);
      }
    };
    document.addEventListener('shopify:section:unload', disconnectRailObserver);
    updateRailActions();
  });
}
document.querySelectorAll('[data-raer-home]').forEach(initRaerHome);
document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-raer-home]').forEach(initRaerHome));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["raer-home"] && !Shopify.designMode) return;
  try {
    
function initRaerHome(root) {
  root.querySelectorAll('[data-raer-signature-size]').forEach((button) => {
    if (button.dataset.raerBound) return;
    button.dataset.raerBound = 'true';
    button.addEventListener('click', () => {
      const form = button.closest('form');
      form.querySelector('[data-raer-signature-variant]').value = button.dataset.variantId;
      const add = form.querySelector('[data-raer-signature-add]');
      add.disabled = false;
      add.textContent = 'Ajouter à la sélection';
      form.querySelectorAll('[data-raer-signature-size]').forEach((choice) => {
        const selected = choice === button;
        choice.classList.toggle('is-selected', selected);
        choice.setAttribute('aria-pressed', String(selected));
      });
    });
  });
  root.querySelectorAll('.product-section').forEach((section) => {
    const rail = section.querySelector('.product-rail');
    const actions = section.querySelector('.rail-actions');
    if (!rail || !actions || rail.dataset.raerBound) return;
    rail.dataset.raerBound = 'true';
    const buttons = actions.querySelectorAll('[data-raer-rail-direction]');
    const updateRailActions = () => {
      const maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
      actions.hidden = maxScroll <= 2;
      buttons.forEach((button) => {
        button.disabled = Number(button.dataset.raerRailDirection) < 0
          ? rail.scrollLeft <= 2
          : rail.scrollLeft >= maxScroll - 2;
      });
    };
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        rail.scrollBy({ left: Number(button.dataset.raerRailDirection) * rail.clientWidth * 0.72, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      });
    });
    rail.addEventListener('scroll', updateRailActions, { passive: true });
    const resizeObserver = new ResizeObserver(updateRailActions);
    resizeObserver.observe(rail);
    rail.querySelectorAll('.product-card').forEach((card) => resizeObserver.observe(card));
    const disconnectRailObserver = (event) => {
      if (event.target.contains(root)) {
        resizeObserver.disconnect();
        document.removeEventListener('shopify:section:unload', disconnectRailObserver);
      }
    };
    document.addEventListener('shopify:section:unload', disconnectRailObserver);
    updateRailActions();
  });
}
document.querySelectorAll('[data-raer-home]').forEach(initRaerHome);
document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-raer-home]').forEach(initRaerHome));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["raer-product-editable"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mount = (scope = document) => {
      scope.querySelectorAll('[data-raer-product]:not([data-raer-ready])').forEach(root => {
        root.dataset.raerReady = 'true';
        const isPreorder = root.dataset.preorder === 'true';
        const data = JSON.parse(root.querySelector('[data-raer-variants]').textContent);
        const form = root.querySelector('.pdp-product-form');
        const select = root.querySelector('[data-variant-select]');
        const groups = [...root.querySelectorAll('[data-option-group]')];
        const addButton = root.querySelector('[data-add-to-cart]');
        const addLabel = root.querySelector('[data-add-label]');
        const mobileButton = root.querySelector('[data-mobile-add]');
        const stock = root.querySelector('[data-stock-text]');
        const message = root.querySelector('[data-cart-message]');
        const cartLink = root.querySelector('[data-cart-link]');
        let selected = data.variants.find(variant => String(variant.id) === select.value);
        let chosen = selected ? [...selected.options] : data.variants[0].options.map((value, index) => groups[index]?.querySelectorAll('[data-option-value]').length === 1 ? value : null);
        let busy = false;
        let fitOrderReport = () => 'Guide non renseigné ; taille commandée : ' + (selected?.title || 'non choisie');
        const updateVariant = (updateUrl = false) => {
          selected = data.variants.find(variant => variant.options.every((value, index) => value === chosen[index]));
          const needsSelection = chosen.some(value => value === null);
          const available = Boolean(selected && selected.available);
          select.value = selected ? String(selected.id) : '';
          addButton.disabled = !available || busy;
          mobileButton.disabled = !available || busy;
          addLabel.textContent = busy ? 'Ajout en cours…' : available ? (isPreorder ? 'Précommander' : 'Ajouter au panier') : needsSelection ? data.ui.choose : selected ? 'Épuisé' : 'Indisponible';
          mobileButton.textContent = busy ? 'Ajout…' : available ? (isPreorder ? 'Précommander' : 'Ajouter') : needsSelection ? data.ui.choose : selected ? 'Épuisé' : 'Indisponible';
          stock.textContent = needsSelection ? data.ui.chooseStock : available ? (isPreorder ? 'Disponible en précommande' : data.isJacket ? (selected.inStock ? data.ui.stock : data.ui.askDelivery) : 'Disponible') : selected ? 'Cette version est épuisée' : 'Cette combinaison est indisponible';
          root.querySelector('[data-stock]').classList.toggle('is-unavailable', !available);
          root.querySelectorAll('[data-product-price]').forEach(element => { element.textContent = selected ? selected.price : data.defaultPrice; });
          root.querySelectorAll('[data-product-reference]').forEach(element => {const reference=selected?selected.reference:data.defaultReference;element.hidden=!reference;element.textContent=reference||'';});
          root.querySelectorAll('[data-installment-price]').forEach(element => { element.textContent = data.installmentTemplate.replace('__PRICE__', selected ? selected.installment : data.defaultInstallment); });
          root.querySelector('[data-mobile-variant]').textContent = data.hasOnlyDefaultVariant ? '' : needsSelection ? data.ui.choose + ' · ' : chosen.join(' / ') + ' · ';
          groups.forEach((group, index) => {
            group.querySelectorAll('[data-option-value]').forEach(button => {
              const value = button.dataset.optionValue;
              const pressed = value === chosen[index];
              const exists = data.variants.some(variant => variant.available && variant.options.every((option, optionIndex) => (optionIndex === index ? option === value : chosen[optionIndex] === null || option === chosen[optionIndex])));
              button.classList.toggle('is-selected', pressed);
              button.classList.toggle('is-unavailable', !exists);
              button.setAttribute('aria-pressed', String(pressed));
              button.setAttribute('aria-label', value + (exists ? '' : ', indisponible pour cette combinaison'));
            });
          });
          if (updateUrl && selected) {
            const url = new URL(location.href);
            url.searchParams.set('variant', selected.id);
            history.replaceState({}, '', url);
          }
        };
        groups.forEach((group, index) => group.querySelectorAll('[data-option-value]').forEach(button => button.addEventListener('click', () => {
          chosen[index] = button.dataset.optionValue;
          message.hidden = true;
          cartLink.hidden = true;
          updateVariant(true);
        })));
        select.addEventListener('change', () => {
          selected = data.variants.find(variant => String(variant.id) === select.value);
          if (selected) chosen = [...selected.options];
          updateVariant(true);
        });
        form.addEventListener('submit', async event => {
          event.preventDefault();
          if (busy || !selected || !selected.available) return;
          busy = true;
          message.hidden = true;
          cartLink.hidden = true;
          updateVariant();
          try {
            const report = form.querySelector('[data-fit-order-report]');
            if (report) report.value = fitOrderReport();
            const response = await fetch(root.dataset.addUrl, {method: 'POST', headers: {'Accept': 'application/json'}, body: new FormData(form)});
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || result.message || 'L’ajout au panier n’a pas pu aboutir. Réessayez.');
            message.textContent = 'La pièce a été ajoutée à votre panier.';
            message.classList.remove('is-error');
            cartLink.hidden = false;
            document.dispatchEvent(new CustomEvent('raer:cart-added', {detail: {item: result}}));
          } catch (error) {
            message.textContent = error.message || 'La connexion a été interrompue. Réessayez.';
            message.classList.add('is-error');
          } finally {
            busy = false;
            message.hidden = false;
            updateVariant();
          }
        });
        let activeDialog = null;
        let returnFocus = null;
        let previousOverflow = '';
        const closeDialog = () => {
          if (!activeDialog) return;
          activeDialog.hidden = true;
          activeDialog = null;
          document.body.style.overflow = previousOverflow;
          if (returnFocus && returnFocus.isConnected) returnFocus.focus();
        };
        const openDialog = dialog => {
          if (!dialog) return;
          if (activeDialog) closeDialog();
          returnFocus = document.activeElement;
          previousOverflow = document.body.style.overflow;
          activeDialog = dialog;
          dialog.hidden = false;
          document.body.style.overflow = 'hidden';
          dialog.querySelector('[data-dialog-close]').focus();
        };
        root.querySelectorAll('[data-dialog-close]').forEach(button => button.addEventListener('click', closeDialog));
        const sizeDialog = root.querySelector('[data-size-dialog]');
        root.querySelectorAll('[data-size-guide-open]').forEach(button => button.addEventListener('click', () => openDialog(sizeDialog)));
        const zoomDialog = root.querySelector('[data-zoom-dialog]');
        const images = [...root.querySelectorAll('[data-zoom-image] img')];
        const largeImage = root.querySelector('[data-zoom-large]');
        let imageIndex = 0;
        const showImage = index => {
          if (!images.length) return;
          imageIndex = (index + images.length) % images.length;
          const image = images[imageIndex];
          largeImage.src = image.src || image.currentSrc;
          largeImage.alt = image.alt;
          root.querySelector('[data-zoom-counter]').textContent = (imageIndex + 1) + ' / ' + images.length;
        };
        root.querySelectorAll('[data-zoom-image]').forEach((button, index) => button.addEventListener('click', () => { showImage(index); openDialog(zoomDialog); }));
        root.querySelector('[data-zoom-previous]').addEventListener('click', () => showImage(imageIndex - 1));
        root.querySelector('[data-zoom-next]').addEventListener('click', () => showImage(imageIndex + 1));
        [sizeDialog, zoomDialog].filter(Boolean).forEach(dialog => dialog.addEventListener('click', event => { if (event.target === dialog) closeDialog(); }));
        root.addEventListener('keydown', event => {
          if (!activeDialog) return;
          if (event.key === 'Escape') { event.preventDefault(); closeDialog(); }
          if (activeDialog === zoomDialog && event.key === 'ArrowLeft') showImage(imageIndex - 1);
          if (activeDialog === zoomDialog && event.key === 'ArrowRight') showImage(imageIndex + 1);
          if (event.key === 'Tab') {
            const focusable = [...activeDialog.querySelectorAll('button, a[href], input, select, summary, [tabindex="0"]')].filter(element => !element.disabled && !element.hidden && element.getClientRects().length > 0);
            const first = focusable[0], last = focusable[focusable.length - 1];
            if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
            else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
          }
        });
        groups.forEach(group => {
          if (!/taille|size/i.test(group.dataset.optionName || '')) return;
          const rank = ['XXS','XS','S','M','L','XL','2XL','XXL','3XL','XXXL'];
          const buttons = [...group.querySelectorAll('[data-option-value]')];
          buttons.sort((a,b) => { const ra = rank.indexOf(a.dataset.optionValue.toUpperCase()), rb = rank.indexOf(b.dataset.optionValue.toUpperCase()); return (ra < 0 ? 99 : ra) - (rb < 0 ? 99 : rb); });
          buttons.forEach(button => button.parentElement.append(button));
        });
        const gallery = root.querySelector('[data-raer-gallery]');
        const galleryMore = root.querySelector('[data-gallery-more]');
        if (images.length > 1) {
          galleryMore.hidden = false;
          galleryMore.textContent = 'Voir les ' + images.length + ' photos';
          galleryMore.addEventListener('click', () => {
            if (window.matchMedia('(max-width:700px)').matches) { showImage(0); openDialog(zoomDialog); }
            else { gallery.classList.toggle('is-expanded'); galleryMore.textContent = gallery.classList.contains('is-expanded') ? 'Réduire la galerie' : 'Voir les ' + images.length + ' photos'; }
          });
        }
const fitDialog = root.querySelector('[data-size-dialog].raer-fit');
if (fitDialog) {
  const fitRank = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL', '5XL'];
  const fitNormalizeSize = value => String(value ?? '').trim().toUpperCase().replace(/^2XL$/, 'XXL');
  const fitNumber = value => {
    if (!/^\d+(?:[,.]\d+)?$/.test(String(value).trim())) return null;
    const number = Number(String(value).trim().replace(',', '.'));
    return Number.isFinite(number) && number > 0 ? number : null;
  };
  const fitBodyAdvice = (chart, heightValue, weightValue) => {
    const height = fitNumber(heightValue), weight = fitNumber(weightValue);
    if (height === null || weight === null) return {status:'missing'};
    if (!Number.isInteger(height) || height < 50 || height > 250 || weight < 20 || weight > 300) return {status:'invalid'};
    if (!chart) return {status:'unsupported'};
    if (height < chart.minHeight || weight < chart.weights[0]) return {status:'unmapped'};
    const row = Math.min(chart.rows.length - 1, Math.floor((height-chart.minHeight)/5));
    let column = 0;
    chart.weights.forEach((value,index) => {if (Math.abs(value-weight) <= Math.abs(chart.weights[column]-weight)) column=index;});
    const cell = chart.rows[row][column];
    const match = {heightBand:height >= chart.lastHeight ? chart.lastHeight+'+' : (chart.minHeight+row*5)+'–'+(chart.minHeight+row*5+4),weightColumn:chart.weights[column]};
    return {...match,status:cell === 'request' ? 'request' : cell ? 'size' : 'unmapped',...(cell && cell !== 'request' ? {size:cell} : {})};
  };

  const fitClosestRows = (rows, width) => {
    const measured = rows.filter(row => fitNumber(row.halfChest) !== null);
    if (!width || !measured.length) return [];
    const widths = measured.map(row => fitNumber(row.halfChest));
    if (width < Math.min(...widths) || width > Math.max(...widths)) return [];
    const distance = Math.min(...widths.map(value => Math.abs(value - width)));
    return measured.filter(row => Math.abs(Math.abs(fitNumber(row.halfChest) - width) - distance) < .001);
  };
  const fitFormat = value => new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 1}).format(value);
  const fitText = (tag, text, className) => {
    const node = document.createElement(tag);
    node.textContent = text;
    if (className) node.className = className;
    return node;
  };
  const fitGet = selector => fitDialog.querySelector(selector);
  const fitFields = [...fitDialog.querySelectorAll('[data-fit-profile]')];
  const fitMeasures = [...fitDialog.querySelectorAll('[data-fit-measure]')];
  const fitNext = fitGet('[data-fit-next]');
  const fitError = fitGet('[data-fit-error]');
  const fitLive = fitGet('[data-fit-live]');
  const fitState = {step: 0, answered: false, compared: false, options: [...chosen], variantId: null};
  const fitBodyData = JSON.parse(fitGet('[data-raer-fit-body]').textContent);
  const fitUI = JSON.parse(fitGet('[data-raer-fit-ui]').textContent);
  const fitAdvice = () => fitBodyAdvice(fitBodyData.chart, fitProfile().height, fitProfile().weight);
  const fitPreorder = root.dataset.preorder === 'true';
  const fitAvailability = fitPreorder ? 'disponible en précommande' : 'disponible';
  let fitOptionNames = [];
  let fitMeasureData = null;
  try { fitOptionNames = JSON.parse(fitGet('[data-raer-fit-options]').textContent); } catch {}
  try { fitMeasureData = JSON.parse(root.querySelector('[data-raer-fit-measures]')?.textContent || 'null'); } catch {}
  if (!Array.isArray(fitOptionNames)) fitOptionNames = [];
  const fitSizeIndex = fitOptionNames.findIndex(name => /taille|size/i.test(String(name)));
  const fitTables = Array.isArray(fitMeasureData?.tables) ? fitMeasureData.tables : fitMeasureData ? [fitMeasureData] : [];
  const fitKeys = [['halfChest', 'Poitrine à plat'], ['backLength', 'Longueur du dos'], ['sleeve', 'Manche depuis le milieu du dos'], ['halfBottom', 'Largeur du bas'], ['halfWaist', 'Largeur de taille']];
  const fitProfile = () => Object.fromEntries(fitFields.map(input => [input.dataset.fitProfile, input.value]));
  const fitReadMeasures = () => Object.fromEntries(fitMeasures.map(input => [input.dataset.fitMeasure, fitNumber(input.value)]).filter(([, value]) => value !== null));
  const fitTable = () => fitTables.find(table => table && table.status === 'verified' && Array.isArray(table.rows) && Object.entries(table.scope || {}).every(([name, value]) => {
    const index = fitOptionNames.indexOf(name);
    return index >= 0 && String(fitState.options[index]) === String(value);
  })) || null;
  const fitRows = () => (fitTable()?.rows || []).filter(row => row && typeof row.size === 'string' && fitKeys.some(([key]) => fitNumber(row[key]) !== null));
  const fitVariants = () => fitSizeIndex < 0 ? data.variants : data.variants.filter(variant => variant.options.every((value, index) => index === fitSizeIndex || value === fitState.options[index]));
  const fitVariant = () => data.variants.find(variant => String(variant.id) === fitState.variantId);
  const fitTarget = () => {const advice = fitAdvice();return fitState.answered && advice.status === 'size' ? fitNormalizeSize(advice.size) : null;};
  const fitNearest = () => fitState.compared ? fitClosestRows(fitRows(), fitReadMeasures().halfChest) : [];
  const fitLabel = variant => data.hasOnlyDefaultVariant ? 'Version unique' : fitSizeIndex >= 0 ? variant.options[fitSizeIndex] : variant.title;
  const fitSetError = text => { fitError.textContent = text; fitError.hidden = !text; };
  const fitValidateProfile = () => {
    let invalid = null;
    fitFields.forEach(input => {
      const key = input.dataset.fitProfile;
      const number = fitNumber(input.value);
      const bad = key === 'height' ? number === null || !Number.isInteger(number) || number < 50 || number > 250 : key === 'weight' ? number === null || number < 20 || number > 300 : false;
      input.setAttribute('aria-invalid', String(bad));
      if (bad && !invalid) invalid = input;
    });
    if (invalid) {
      fitSetError(fitUI.invalid_profile);
      invalid.focus(); return false;
    }
    fitSetError(''); return true;
  };
  const fitValidateMeasures = () => {
    let invalid = null;
    fitMeasures.forEach(input => {
      const bad = input.value.trim() !== '' && fitNumber(input.value) === null;
      input.setAttribute('aria-invalid', String(bad));
      if (bad && !invalid) invalid = input;
    });
    if (invalid) { fitSetError('Indiquez une mesure positive en centimètres, ou laissez le champ vide.'); invalid.focus(); return false; }
    fitSetError(''); return true;
  };
  const fitSourceLink = () => {
    try {
      if (!fitTable()?.sourceUrl) return null;
      const url = new URL(fitTable().sourceUrl, location.origin);
      if (!['https:', 'http:'].includes(url.protocol)) return null;
      const link = fitText('a', 'Voir le tableau RAER d’origine', 'raer-fit__inline');
      link.href = url.href; link.target = '_blank'; link.rel = 'noopener';
      link.setAttribute('aria-label', 'Voir le tableau RAER d’origine, nouvel onglet');
      return link;
    } catch { return null; }
  };
  const fitRenderTable = () => {
    const host = fitGet('[data-fit-measure-table]');
    const rows = fitRows(); host.replaceChildren();
    fitGet('.raer-fit__measurements').hidden = !rows.length;
    fitGet('.raer-fit__drawing figcaption').textContent = rows.length ? 'Les valeurs du tableau sont les dimensions du vêtement à plat, en centimètres.' : 'Les mesures de cette version restent à confirmer auprès de RAER.';
    fitGet('[data-fit-table-details]').hidden = !rows.length;
    fitGet('[data-fit-table-notice]').hidden = !!rows.length;
    if (!rows.length) return;
    const columns = fitKeys.filter(([key]) => rows.some(row => fitNumber(row[key]) !== null));
    const table = document.createElement('table');
    table.append(fitText('caption', 'Dimensions du vêtement à plat · cm'));
    const head = document.createElement('thead'); const tr = document.createElement('tr');
    ['Taille', ...columns.map(([, label]) => label)].forEach(label => { const th = fitText('th', label); th.scope = 'col'; tr.append(th); });
    head.append(tr); table.append(head);
    const body = document.createElement('tbody');
    rows.forEach(row => {
      const line = document.createElement('tr'); const size = fitText('th', row.size); size.scope = 'row'; line.append(size);
      columns.forEach(([key]) => line.append(fitText('td', fitNumber(row[key]) === null ? '—' : fitFormat(fitNumber(row[key])))));
      body.append(line);
    });
    table.append(body); host.append(table);
    host.append(fitText('p', 'Les tours du corps et les largeurs d’une veste ne sont pas directement comparables.', 'raer-fit__quiet'));
    const link = fitSourceLink(); if (link) host.append(link);
  };
  const fitRenderResult = () => {
    const profile=fitProfile(), advice=fitAdvice(), target=fitTarget();
    const title=fitGet('[data-fit-result-title]'), copy=fitGet('[data-fit-result-copy]');
    title.textContent=target ? fitUI.recommended+advice.size : advice.status==='request' ? fitUI.on_request : advice.status==='unsupported' ? fitUI.no_chart : advice.status==='missing' || advice.status==='invalid' ? fitUI.missing : fitUI.no_match;
    copy.textContent=target ? fitUI.chart_copy : fitUI.contact_copy;
    const context=fitVariants().filter(variant=>fitNormalizeSize(fitLabel(variant))===target);
    if(target && !context.length)copy.textContent+=' '+fitUI.not_offered+' '+fitUI.contact_copy;
    else if(target && !context.some(variant=>variant.available))copy.textContent+=' '+fitUI.epuise+' '+fitUI.contact_copy;
    const rep=[];
    if(fitNumber(profile.height)!==null)rep.push(fitFormat(fitNumber(profile.height))+' cm');
    if(fitNumber(profile.weight)!==null)rep.push(fitFormat(fitNumber(profile.weight))+' kg');
    if(advice.weightColumn)rep.push('col. '+advice.weightColumn+' kg');
    fitGet('[data-fit-profile-summary]').textContent=fitUI.profile_summary+' '+(fitBodyData.type==='women'?fitUI.women:fitUI.men)+' · '+rep.join(' · ');
    fitGet('[data-fit-layer-note]').textContent=profile.layers==='warm' ? 'Avec une couche chaude, vérifiez l’aisance au buste et aux bras. Le conseil du tableau n’est pas modifié.' : profile.layers==='knit' ? 'Gardez votre maille légère pour vérifier le confort, veste fermée et bras avancés.' : 'Vérifiez le confort avec la couche et les protections prévues pour le modèle.';
  };

  const fitRenderNearest = () => {
    const host = fitGet('[data-fit-nearest]'); host.replaceChildren(); host.hidden = true;
    if (!fitState.compared) return;
    const width = fitReadMeasures().halfChest; const rows = fitNearest(); const all = fitRows();
    if (!all.length) return;
    host.hidden = false;
    if (!width) { host.append(fitText('p', 'Ajoutez la largeur de poitrine de votre veste pour repérer les tailles les plus proches. Les longueurs se comparent avec la taille que vous choisissez ci-dessous.')); return; }
    if (!rows.length) { host.append(fitText('strong', 'Cette largeur se situe hors de la plage du tableau.')); host.append(fitText('p', 'Vérifiez la mesure d’aisselle à aisselle, ou demandez conseil à RAER. Aucune taille n’est déduite en dehors du tableau.')); return; }
    host.append(fitText('strong', rows.length === 1 ? 'La plus proche en largeur : ' + rows[0].size : 'Les plus proches en largeur : ' + rows.map(row => row.size).join(' et ')));
    rows.forEach(row => {
      const delta = fitNumber(row.halfChest) - width;
      const variants = fitVariants().filter(variant => fitNormalizeSize(fitLabel(variant)) === fitNormalizeSize(row.size));
      const status = variants.length ? variants.some(variant => variant.available) ? '' : ' Taille épuisée dans cette version.' : ' Taille non proposée dans cette version.';
      host.append(fitText('p', row.size + ' : ' + fitFormat(fitNumber(row.halfChest)) + ' cm, soit ' + (delta > 0 ? '+' : '') + fitFormat(delta) + ' cm par rapport à votre veste.' + status));
    });
    host.append(fitText('p', 'Cette comparaison porte seulement sur la largeur. Vérifiez aussi les longueurs et l’aisance en mouvement.'));
  };
  const fitRenderComparison = () => {
    const host = fitGet('[data-fit-comparison]'); host.replaceChildren(); host.hidden = true;
    if (fitState.step !== 1 || !fitVariant()) return;
    const size = fitNormalizeSize(fitLabel(fitVariant()));
    const row = fitRows().find(item => fitNormalizeSize(item.size) === size);
    if (!row) {
      if (fitRows().length) { host.hidden = false; host.append(fitText('p', 'Les mesures de la taille ' + fitLabel(fitVariant()) + ' ne figurent pas dans ce tableau. Nous ne les déduisons pas des tailles voisines.', 'raer-fit__quiet')); }
      return;
    }
    host.hidden = false;
    const measures = fitState.compared ? fitReadMeasures() : {};
    const comparing = Object.keys(measures).length > 0;
    const table = document.createElement('table'); table.append(fitText('caption', 'Taille ' + row.size + ' · dimensions à plat'));
    const head = document.createElement('thead'); const tr = document.createElement('tr');
    ['Mesure', 'RAER', ...(comparing ? ['Votre veste', 'Écart'] : [])].forEach(text => { const th = fitText('th', text); th.scope = 'col'; tr.append(th); }); head.append(tr); table.append(head);
    const body = document.createElement('tbody');
    fitKeys.filter(([key]) => fitNumber(row[key]) !== null).forEach(([key, label]) => {
      const line = document.createElement('tr'); const th = fitText('th', label); th.scope = 'row'; line.append(th, fitText('td', fitFormat(fitNumber(row[key])) + ' cm'));
      if (comparing) {
        const value = measures[key]; const delta = value === undefined ? null : fitNumber(row[key]) - value;
        line.append(fitText('td', value === undefined ? '—' : fitFormat(value) + ' cm'), fitText('td', delta === null ? '—' : (delta > 0 ? '+' : '') + fitFormat(delta) + ' cm'));
      }
      body.append(line);
    });
    table.append(body); host.append(table);
  };
  const fitUpdateAction = () => {
    const choosing = fitState.answered || fitState.step === 1;
    const variant = fitVariant();
    fitNext.disabled = choosing && !variant?.available;
    fitNext.textContent = !choosing ? fitUI.see : variant?.available ? 'Choisir ' + (data.hasOnlyDefaultVariant ? 'cette version' : 'la taille ' + fitLabel(variant)) : 'Choisir une taille';
    fitGet('[data-fit-back]').hidden = fitState.step === 0;
    fitGet('[data-fit-verify]').hidden = fitState.step === 1;
  };
  const fitRenderSizes = () => {
    const host = fitGet('[data-fit-sizes]'); host.replaceChildren();
    const nearest = fitNearest().map(row => fitNormalizeSize(row.size));
    const variants = [...fitVariants()].sort((a, b) => { const ai = fitRank.indexOf(fitNormalizeSize(fitLabel(a))), bi = fitRank.indexOf(fitNormalizeSize(fitLabel(b))); return (ai < 0 ? 99 : ai) - (bi < 0 ? 99 : bi); });
    variants.forEach(variant => {
      const label = fitLabel(variant); const button = document.createElement('button'); button.type = 'button'; button.disabled = !variant.available;
      button.append(fitText('span', label));
      button.setAttribute('aria-pressed', String(String(variant.id) === fitState.variantId));
      button.setAttribute('aria-label', label + (variant.available ? ', ' + fitAvailability : ', épuisé'));
      if (!variant.available) button.append(fitText('small', 'Épuisé'));
      else if (fitState.step === 1 && nearest.includes(fitNormalizeSize(label))) button.append(fitText('small', 'Largeur proche'));
      else if (fitNormalizeSize(label) === fitTarget()) button.append(fitText('small', 'Votre repère'));
      else if (fitPreorder) button.append(fitText('small', 'Précommande'));
      button.addEventListener('click', () => { fitState.variantId = String(variant.id); fitSetError(''); fitRenderSizes(); host.querySelector('[aria-pressed="true"]')?.focus({preventScroll: true}); });
      host.append(button);
    });
    const variant = fitVariant();
    fitGet('[data-fit-availability]').textContent = variant?.available ? variant.title + ' · ' + fitAvailability + ' · ' + variant.price : variants.some(item => item.available) ? 'Choisissez une taille. Le bouton ci-dessous la sélectionne sur la fiche, sans l’ajouter au panier.' : 'Cette version est actuellement épuisée.';
    fitRenderComparison(); fitUpdateAction();
  };
  const fitRenderOptions = () => {
    const host = fitGet('[data-fit-options]'); host.replaceChildren();
    if (fitSizeIndex < 0) return;
    fitOptionNames.forEach((name, index) => {
      if (index === fitSizeIndex) return;
      const values = [...new Set(data.variants.map(variant => variant.options[index]))];
      if (values.length < 2) return;
      const label = fitText('label', name, 'raer-fit__option'); const select = document.createElement('select'); select.setAttribute('aria-label', String(name));
      values.forEach(value => { const option = fitText('option', value); option.value = value; select.append(option); });
      select.value = fitState.options[index] || values[0];
      select.addEventListener('change', () => {
        fitState.options[index] = select.value; fitState.variantId = null;
        if (!fitVariants().length) { const match = data.variants.find(variant => variant.options[index] === select.value); if (match) fitState.options = [...match.options]; }
        fitRenderAll();
        const nextControl = [...host.querySelectorAll('select')].find(control => control.getAttribute('aria-label') === String(name));
        nextControl?.focus({preventScroll: true});
      });
      label.append(select); host.append(label);
    });
  };
  function fitRenderAll() {
    fitGet('[data-fit-question-panel]').hidden = fitState.answered;
    fitGet('[data-fit-result]').hidden = !fitState.answered;
    fitGet('[data-fit-selection]').hidden = !fitState.answered && fitState.step === 0;
    if (fitState.answered) fitRenderResult();
    fitRenderTable(); fitRenderOptions(); fitRenderNearest(); fitRenderSizes();
  }
  function fitGo(step, focus = true) {
    fitState.step = step === 1 ? 1 : 0;
    fitDialog.querySelectorAll('[data-fit-step]').forEach(panel => { panel.hidden = Number(panel.dataset.fitStep) !== fitState.step; });
    fitDialog.querySelectorAll('[data-fit-go]').forEach(button => { if (Number(button.dataset.fitGo) === fitState.step) button.setAttribute('aria-current', 'step'); else button.removeAttribute('aria-current'); });
    fitSetError(''); fitRenderAll(); fitGet('[data-fit-scroll]').scrollTop = 0;
    fitLive.textContent = fitState.step === 1 ? 'Vérification facultative des mesures.' : fitState.answered ? 'Votre premier repère et les tailles proposées.' : 'Quatre questions pour préparer votre choix.';
    if (focus) (fitState.step === 0 && fitState.answered ? fitGet('[data-fit-result-title]') : fitGet('[data-fit-step="' + fitState.step + '"] [data-fit-heading]')).focus({preventScroll: true});
  }
  const fitSubmitQuick = () => {
    if (!fitValidateProfile()) return;
    fitState.answered = true;
    const target = fitTarget();
    const match = fitVariants().find(variant => variant.available && fitNormalizeSize(fitLabel(variant)) === target);
    fitState.variantId = match ? String(match.id) : null;
    fitGo(0);
  };
  fitNext.addEventListener('click', () => {
    if (!fitState.answered && fitState.step === 0) { fitSubmitQuick(); return; }
    const variant = fitVariant();
    if (!variant?.available) { fitSetError('Choisissez une taille disponible pour revenir à la fiche.'); return; }
    chosen = [...variant.options]; updateVariant(true); closeDialog();
    root.querySelector('[data-cart-message]')?.setAttribute('hidden', '');
    root.querySelector('[data-cart-link]')?.setAttribute('hidden', '');
  });
  fitGet('[data-fit-question-panel]').addEventListener('keydown', event => { if (event.key === 'Enter' && event.target.tagName === 'INPUT') { event.preventDefault(); fitSubmitQuick(); } });
  fitDialog.querySelectorAll('[data-fit-go]').forEach(button => button.addEventListener('click', () => fitGo(Number(button.dataset.fitGo))));
  fitGet('[data-fit-check-direct]').addEventListener('click', () => fitGo(1));
  fitGet('[data-fit-verify]').addEventListener('click', () => fitGo(1));
  fitGet('[data-fit-back]').addEventListener('click', () => fitGo(0));
  fitGet('[data-fit-edit]').addEventListener('click', () => { fitState.answered = false; fitState.variantId = null; fitGo(0); });
  fitGet('[data-fit-compare]').addEventListener('click', () => {
    if (!fitValidateMeasures()) return;
    fitState.compared = true; fitRenderNearest(); fitRenderSizes();
    fitLive.textContent = fitNearest().length ? 'Comparaison mise à jour. Tailles les plus proches en largeur : ' + fitNearest().map(row => row.size).join(', ') + '.' : 'Comparaison mise à jour. Consultez les mesures et les indications affichées.';
  });
  fitMeasures.forEach(input => input.addEventListener('input', () => { fitState.compared = false; input.removeAttribute('aria-invalid'); fitSetError(''); fitRenderNearest(); fitRenderComparison(); }));
  fitGet('[data-fit-restart]').addEventListener('click', () => {
    [...fitFields, ...fitMeasures].forEach(input => { input.value = ''; input.removeAttribute('aria-invalid'); });
    fitState.answered = false; fitState.compared = false; fitState.variantId = null; fitState.options = [...chosen];
    fitGet('[data-fit-table-details]').open = false; fitGo(0);
  });
  fitGet('[data-fit-protection-note]').textContent = root.dataset.fitPads === 'true' ? 'Pour un usage moto, faites cet essai avec les protections prévues dans leurs emplacements. Consultez la fiche pour savoir si elles sont fournies.' : 'Si vous portez une protection sous la veste, gardez-la pour vérifier le confort avec votre couche habituelle.';
  root.querySelectorAll('[data-size-guide-open]').forEach(button => button.addEventListener('click', () => {
    fitState.options = [...chosen]; fitState.variantId = null; fitState.answered = false; fitState.compared = false;
    fitGo(0, false);
  }));
  fitOrderReport = () => {
    const profile=fitProfile(), advice=fitAdvice();
    const label=data.hasOnlyDefaultVariant ? selected?.title : selected?.options[fitSizeIndex] || selected?.title;
    const parts=['Guide RAER 02/11/2026', 'Tableau : '+(fitBodyData.type==='women'?'Femme / DONNA CA-WX':fitBodyData.type==='men'?'Homme / ARTIST-ASCONA 2 CA-WX':'non disponible pour ce modèle')];
    if(fitNumber(profile.height)!==null)parts.push('Stature : '+fitFormat(fitNumber(profile.height))+' cm');
    if(fitNumber(profile.weight)!==null)parts.push('Poids : '+fitFormat(fitNumber(profile.weight))+' kg');
    if(profile.usual && profile.usual!=='unknown')parts.push('Taille habituelle déclarée (indicative) : '+profile.usual);
    const layer={light:'T-shirt / chemise',knit:'maille légère',warm:'couche chaude'}[profile.layers];
    if(layer)parts.push('Couche : '+layer);
    if(advice.heightBand)parts.push('Calage : '+advice.heightBand+' cm / colonne '+advice.weightColumn+' kg (poids le plus proche ; égalité vers le haut)');
    parts.push('Conseil : '+(advice.status==='size'?advice.size:advice.status==='request'?'sur demande':advice.status==='missing'?'guide non renseigné':advice.status==='unsupported'?'tableau absent, conseil RAER requis':'aucune correspondance, conseil RAER requis'));
    if(label)parts.push('Taille commandée : '+label);
    if(advice.status==='size' && label && fitNormalizeSize(label)!==fitNormalizeSize(advice.size))parts.push('ATTENTION : choix différent du conseil du tableau');
    const measures=fitReadMeasures();
    fitKeys.forEach(([key,name])=>{if(measures[key]!==undefined)parts.push('Veste de référence / '+name+' : '+fitFormat(measures[key])+' cm')});
    return parts.join(' ; ');
  };

  fitGo(0, false);
}

        root.classList.add('is-enhanced');
        updateVariant();
        document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) closeDialog(); });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount());
    else mount();
    document.addEventListener('shopify:section:load', event => mount(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["raer-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mount = (scope = document) => {
      scope.querySelectorAll('[data-raer-product]:not([data-raer-ready])').forEach(root => {
        root.dataset.raerReady = 'true';
        const isPreorder = root.dataset.preorder === 'true';
        const data = JSON.parse(root.querySelector('[data-raer-variants]').textContent);
        const form = root.querySelector('.pdp-product-form');
        const select = root.querySelector('[data-variant-select]');
        const groups = [...root.querySelectorAll('[data-option-group]')];
        const addButton = root.querySelector('[data-add-to-cart]');
        const addLabel = root.querySelector('[data-add-label]');
        const mobileButton = root.querySelector('[data-mobile-add]');
        const stock = root.querySelector('[data-stock-text]');
        const message = root.querySelector('[data-cart-message]');
        const cartLink = root.querySelector('[data-cart-link]');
        let selected = data.variants.find(variant => String(variant.id) === select.value);
        let chosen = selected ? [...selected.options] : data.variants[0].options.map((value, index) => groups[index]?.querySelectorAll('[data-option-value]').length === 1 ? value : null);
        let busy = false;
        const updateVariant = (updateUrl = false) => {
          selected = data.variants.find(variant => variant.options.every((value, index) => value === chosen[index]));
          const needsSelection = chosen.some(value => value === null);
          const available = Boolean(selected && selected.available);
          select.value = selected ? String(selected.id) : '';
          addButton.disabled = !available || busy;
          mobileButton.disabled = !available || busy;
          addLabel.textContent = busy ? 'Ajout en cours…' : available ? (isPreorder ? 'Précommander' : 'Ajouter au panier') : needsSelection ? data.ui.choose : selected ? 'Épuisé' : 'Indisponible';
          mobileButton.textContent = busy ? 'Ajout…' : available ? (isPreorder ? 'Précommander' : 'Ajouter') : needsSelection ? data.ui.choose : selected ? 'Épuisé' : 'Indisponible';
          stock.textContent = needsSelection ? data.ui.chooseStock : available ? (isPreorder ? 'Disponible en précommande' : data.isJacket ? (selected.inStock ? data.ui.stock : data.ui.askDelivery) : 'Disponible') : selected ? 'Cette version est épuisée' : 'Cette combinaison est indisponible';
          root.querySelector('[data-stock]').classList.toggle('is-unavailable', !available);
          root.querySelectorAll('[data-product-price]').forEach(element => { element.textContent = selected ? selected.price : data.defaultPrice; });
          root.querySelectorAll('[data-installment-price]').forEach(element => { element.textContent = data.installmentTemplate.replace('__PRICE__', selected ? selected.installment : data.defaultInstallment); });
          root.querySelector('[data-mobile-variant]').textContent = data.hasOnlyDefaultVariant ? '' : needsSelection ? data.ui.choose + ' · ' : chosen.join(' / ') + ' · ';
          groups.forEach((group, index) => {
            group.querySelectorAll('[data-option-value]').forEach(button => {
              const value = button.dataset.optionValue;
              const pressed = value === chosen[index];
              const exists = data.variants.some(variant => variant.available && variant.options.every((option, optionIndex) => (optionIndex === index ? option === value : chosen[optionIndex] === null || option === chosen[optionIndex])));
              button.classList.toggle('is-selected', pressed);
              button.classList.toggle('is-unavailable', !exists);
              button.setAttribute('aria-pressed', String(pressed));
              button.setAttribute('aria-label', value + (exists ? '' : ', indisponible pour cette combinaison'));
            });
          });
          if (updateUrl && selected) {
            const url = new URL(location.href);
            url.searchParams.set('variant', selected.id);
            history.replaceState({}, '', url);
          }
        };
        groups.forEach((group, index) => group.querySelectorAll('[data-option-value]').forEach(button => button.addEventListener('click', () => {
          chosen[index] = button.dataset.optionValue;
          message.hidden = true;
          cartLink.hidden = true;
          updateVariant(true);
        })));
        select.addEventListener('change', () => {
          selected = data.variants.find(variant => String(variant.id) === select.value);
          if (selected) chosen = [...selected.options];
          updateVariant(true);
        });
        form.addEventListener('submit', async event => {
          event.preventDefault();
          if (busy || !selected || !selected.available) return;
          busy = true;
          message.hidden = true;
          cartLink.hidden = true;
          updateVariant();
          try {
            const response = await fetch(root.dataset.addUrl, {method: 'POST', headers: {'Accept': 'application/json'}, body: new FormData(form)});
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || result.message || 'L’ajout au panier n’a pas pu aboutir. Réessayez.');
            message.textContent = 'La pièce a été ajoutée à votre panier.';
            message.classList.remove('is-error');
            cartLink.hidden = false;
            document.dispatchEvent(new CustomEvent('raer:cart-added', {detail: {item: result}}));
          } catch (error) {
            message.textContent = error.message || 'La connexion a été interrompue. Réessayez.';
            message.classList.add('is-error');
          } finally {
            busy = false;
            message.hidden = false;
            updateVariant();
          }
        });
        let activeDialog = null;
        let returnFocus = null;
        let previousOverflow = '';
        const closeDialog = () => {
          if (!activeDialog) return;
          activeDialog.hidden = true;
          activeDialog = null;
          document.body.style.overflow = previousOverflow;
          if (returnFocus && returnFocus.isConnected) returnFocus.focus();
        };
        const openDialog = dialog => {
          if (!dialog) return;
          if (activeDialog) closeDialog();
          returnFocus = document.activeElement;
          previousOverflow = document.body.style.overflow;
          activeDialog = dialog;
          dialog.hidden = false;
          document.body.style.overflow = 'hidden';
          dialog.querySelector('[data-dialog-close]').focus();
        };
        root.querySelectorAll('[data-dialog-close]').forEach(button => button.addEventListener('click', closeDialog));
        const sizeDialog = root.querySelector('[data-size-dialog]');
        root.querySelectorAll('[data-size-guide-open]').forEach(button => button.addEventListener('click', () => openDialog(sizeDialog)));
        const zoomDialog = root.querySelector('[data-zoom-dialog]');
        const images = [...root.querySelectorAll('[data-zoom-image] img')];
        const largeImage = root.querySelector('[data-zoom-large]');
        let imageIndex = 0;
        const showImage = index => {
          if (!images.length) return;
          imageIndex = (index + images.length) % images.length;
          const image = images[imageIndex];
          largeImage.src = image.src || image.currentSrc;
          largeImage.alt = image.alt;
          root.querySelector('[data-zoom-counter]').textContent = (imageIndex + 1) + ' / ' + images.length;
        };
        root.querySelectorAll('[data-zoom-image]').forEach((button, index) => button.addEventListener('click', () => { showImage(index); openDialog(zoomDialog); }));
        root.querySelector('[data-zoom-previous]').addEventListener('click', () => showImage(imageIndex - 1));
        root.querySelector('[data-zoom-next]').addEventListener('click', () => showImage(imageIndex + 1));
        [sizeDialog, zoomDialog].filter(Boolean).forEach(dialog => dialog.addEventListener('click', event => { if (event.target === dialog) closeDialog(); }));
        root.addEventListener('keydown', event => {
          if (!activeDialog) return;
          if (event.key === 'Escape') { event.preventDefault(); closeDialog(); }
          if (activeDialog === zoomDialog && event.key === 'ArrowLeft') showImage(imageIndex - 1);
          if (activeDialog === zoomDialog && event.key === 'ArrowRight') showImage(imageIndex + 1);
          if (event.key === 'Tab') {
            const focusable = [...activeDialog.querySelectorAll('button, a[href], input, select, summary, [tabindex="0"]')].filter(element => !element.disabled && !element.hidden && element.getClientRects().length > 0);
            const first = focusable[0], last = focusable[focusable.length - 1];
            if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
            else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
          }
        });
        groups.forEach(group => {
          if (!/taille|size/i.test(group.dataset.optionName || '')) return;
          const rank = ['XXS','XS','S','M','L','XL','2XL','XXL','3XL','XXXL'];
          const buttons = [...group.querySelectorAll('[data-option-value]')];
          buttons.sort((a,b) => { const ra = rank.indexOf(a.dataset.optionValue.toUpperCase()), rb = rank.indexOf(b.dataset.optionValue.toUpperCase()); return (ra < 0 ? 99 : ra) - (rb < 0 ? 99 : rb); });
          buttons.forEach(button => button.parentElement.append(button));
        });
        const gallery = root.querySelector('[data-raer-gallery]');
        const galleryMore = root.querySelector('[data-gallery-more]');
        if (images.length > 1) {
          galleryMore.hidden = false;
          galleryMore.textContent = 'Voir les ' + images.length + ' photos';
          galleryMore.addEventListener('click', () => {
            if (window.matchMedia('(max-width:700px)').matches) { showImage(0); openDialog(zoomDialog); }
            else { gallery.classList.toggle('is-expanded'); galleryMore.textContent = gallery.classList.contains('is-expanded') ? 'Réduire la galerie' : 'Voir les ' + images.length + ' photos'; }
          });
        }
const fitDialog = root.querySelector('[data-size-dialog].raer-fit');
if (fitDialog) {
  const fitRank = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL', '5XL'];
  const fitNormalizeSize = value => String(value ?? '').trim().toUpperCase().replace(/^2XL$/, 'XXL');
  const fitNumber = value => {
    if (!/^\d+(?:[,.]\d+)?$/.test(String(value).trim())) return null;
    const number = Number(String(value).trim().replace(',', '.'));
    return Number.isFinite(number) && number > 0 ? number : null;
  };
  const fitUsualTarget = (usual, small) => {
    const normalized = fitNormalizeSize(usual);
    const index = fitRank.indexOf(normalized);
    if (index < 0) return null;
    return small ? fitRank[index + 1] || null : normalized;
  };
  const fitClosestRows = (rows, width) => {
    const measured = rows.filter(row => fitNumber(row.halfChest) !== null);
    if (!width || !measured.length) return [];
    const widths = measured.map(row => fitNumber(row.halfChest));
    if (width < Math.min(...widths) || width > Math.max(...widths)) return [];
    const distance = Math.min(...widths.map(value => Math.abs(value - width)));
    return measured.filter(row => Math.abs(Math.abs(fitNumber(row.halfChest) - width) - distance) < .001);
  };
  const fitFormat = value => new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 1}).format(value);
  const fitText = (tag, text, className) => {
    const node = document.createElement(tag);
    node.textContent = text;
    if (className) node.className = className;
    return node;
  };
  const fitGet = selector => fitDialog.querySelector(selector);
  const fitFields = [...fitDialog.querySelectorAll('[data-fit-profile]')];
  const fitMeasures = [...fitDialog.querySelectorAll('[data-fit-measure]')];
  const fitNext = fitGet('[data-fit-next]');
  const fitError = fitGet('[data-fit-error]');
  const fitLive = fitGet('[data-fit-live]');
  const fitState = {step: 0, answered: false, compared: false, options: [...chosen], variantId: null};
  const fitSmall = root.dataset.fitSmall === 'true';
  const fitPreorder = root.dataset.preorder === 'true';
  const fitAvailability = fitPreorder ? 'disponible en précommande' : 'disponible';
  let fitOptionNames = [];
  let fitMeasureData = null;
  try { fitOptionNames = JSON.parse(fitGet('[data-raer-fit-options]').textContent); } catch {}
  try { fitMeasureData = JSON.parse(root.querySelector('[data-raer-fit-measures]')?.textContent || 'null'); } catch {}
  if (!Array.isArray(fitOptionNames)) fitOptionNames = [];
  const fitSizeIndex = fitOptionNames.findIndex(name => /taille|size/i.test(String(name)));
  const fitTables = Array.isArray(fitMeasureData?.tables) ? fitMeasureData.tables : fitMeasureData ? [fitMeasureData] : [];
  const fitKeys = [['halfChest', 'Poitrine à plat'], ['backLength', 'Longueur du dos'], ['sleeve', 'Manche depuis le milieu du dos'], ['halfBottom', 'Largeur du bas'], ['halfWaist', 'Largeur de taille']];
  const fitProfile = () => Object.fromEntries(fitFields.map(input => [input.dataset.fitProfile, input.value]));
  const fitReadMeasures = () => Object.fromEntries(fitMeasures.map(input => [input.dataset.fitMeasure, fitNumber(input.value)]).filter(([, value]) => value !== null));
  const fitTable = () => fitTables.find(table => table && table.status === 'verified' && Array.isArray(table.rows) && Object.entries(table.scope || {}).every(([name, value]) => {
    const index = fitOptionNames.indexOf(name);
    return index >= 0 && String(fitState.options[index]) === String(value);
  })) || null;
  const fitRows = () => (fitTable()?.rows || []).filter(row => row && typeof row.size === 'string' && fitKeys.some(([key]) => fitNumber(row[key]) !== null));
  const fitVariants = () => fitSizeIndex < 0 ? data.variants : data.variants.filter(variant => variant.options.every((value, index) => index === fitSizeIndex || value === fitState.options[index]));
  const fitVariant = () => data.variants.find(variant => String(variant.id) === fitState.variantId);
  const fitTarget = () => fitState.answered ? fitUsualTarget(fitProfile().usual, fitSmall) : null;
  const fitNearest = () => fitState.compared ? fitClosestRows(fitRows(), fitReadMeasures().halfChest) : [];
  const fitLabel = variant => data.hasOnlyDefaultVariant ? 'Version unique' : fitSizeIndex >= 0 ? variant.options[fitSizeIndex] : variant.title;
  const fitSetError = text => { fitError.textContent = text; fitError.hidden = !text; };
  const fitValidateProfile = () => {
    let invalid = null;
    fitFields.forEach(input => {
      const key = input.dataset.fitProfile;
      const optional = key === 'height' || key === 'weight';
      const bad = optional ? input.value.trim() !== '' && fitNumber(input.value) === null : input.value === '';
      input.setAttribute('aria-invalid', String(bad));
      if (bad && !invalid) invalid = input;
    });
    if (invalid) {
      fitSetError('Choisissez votre taille habituelle et votre habitude de port. Les valeurs facultatives doivent être positives, en cm et en kg.');
      invalid.focus(); return false;
    }
    fitSetError(''); return true;
  };
  const fitValidateMeasures = () => {
    let invalid = null;
    fitMeasures.forEach(input => {
      const bad = input.value.trim() !== '' && fitNumber(input.value) === null;
      input.setAttribute('aria-invalid', String(bad));
      if (bad && !invalid) invalid = input;
    });
    if (invalid) { fitSetError('Indiquez une mesure positive en centimètres, ou laissez le champ vide.'); invalid.focus(); return false; }
    fitSetError(''); return true;
  };
  const fitSourceLink = () => {
    try {
      if (!fitTable()?.sourceUrl) return null;
      const url = new URL(fitTable().sourceUrl, location.origin);
      if (!['https:', 'http:'].includes(url.protocol)) return null;
      const link = fitText('a', 'Voir le tableau RAER d’origine', 'raer-fit__inline');
      link.href = url.href; link.target = '_blank'; link.rel = 'noopener';
      link.setAttribute('aria-label', 'Voir le tableau RAER d’origine, nouvel onglet');
      return link;
    } catch { return null; }
  };
  const fitRenderTable = () => {
    const host = fitGet('[data-fit-measure-table]');
    const rows = fitRows(); host.replaceChildren();
    fitGet('.raer-fit__measurements').hidden = !rows.length;
    fitGet('.raer-fit__drawing figcaption').textContent = rows.length ? 'Les valeurs du tableau sont les dimensions du vêtement à plat, en centimètres.' : 'Les mesures de cette version restent à confirmer auprès de RAER.';
    fitGet('[data-fit-table-details]').hidden = !rows.length;
    fitGet('[data-fit-table-notice]').hidden = !!rows.length;
    if (!rows.length) return;
    const columns = fitKeys.filter(([key]) => rows.some(row => fitNumber(row[key]) !== null));
    const table = document.createElement('table');
    table.append(fitText('caption', 'Dimensions du vêtement à plat · cm'));
    const head = document.createElement('thead'); const tr = document.createElement('tr');
    ['Taille', ...columns.map(([, label]) => label)].forEach(label => { const th = fitText('th', label); th.scope = 'col'; tr.append(th); });
    head.append(tr); table.append(head);
    const body = document.createElement('tbody');
    rows.forEach(row => {
      const line = document.createElement('tr'); const size = fitText('th', row.size); size.scope = 'row'; line.append(size);
      columns.forEach(([key]) => line.append(fitText('td', fitNumber(row[key]) === null ? '—' : fitFormat(fitNumber(row[key])))));
      body.append(line);
    });
    table.append(body); host.append(table);
    host.append(fitText('p', 'Les tours du corps et les largeurs d’une veste ne sont pas directement comparables.', 'raer-fit__quiet'));
    const link = fitSourceLink(); if (link) host.append(link);
  };
  const fitRenderResult = () => {
    const profile = fitProfile(); const target = fitTarget();
    const title = fitGet('[data-fit-result-title]'); const copy = fitGet('[data-fit-result-copy]');
    title.textContent = target ? 'Commencez par la taille ' + target + '.' : 'Partons de votre veste de référence.';
    copy.textContent = target ? fitSmall ? 'Cette version taille petit : RAER conseille une taille au-dessus de votre taille habituelle (' + fitNormalizeSize(profile.usual) + '). Vérifiez ensuite votre aisance.' : 'Votre taille habituelle (' + target + ') donne un premier repère. Ce n’est pas une estimation à partir de vos mensurations : le tableau vous permet de vérifier ce choix.' : 'Sans taille habituelle, nous ne déduisons pas de taille de votre stature ou de votre poids. Comparez une veste qui vous va avec les mesures de cette pièce.';
    const context = fitVariants().filter(variant => fitNormalizeSize(fitLabel(variant)) === target);
    if (target && !context.length) {
      title.textContent = 'La taille ' + target + ' n’est pas proposée.';
      copy.textContent = 'Votre repère ne correspond pas aux tailles de cette version. Aucune autre taille ne le remplace automatiquement. Demandez conseil à RAER avant de choisir.';
    } else if (target && !context.some(variant => variant.available)) {
      title.textContent = 'Votre repère : ' + target + ', actuellement épuisé.';
      copy.textContent += ' Aucune autre taille ne la remplace automatiquement.';
    } else if (!fitRows().length) {
      copy.textContent = target ? 'Votre taille habituelle (' + target + ') est un premier repère indicatif. Les mesures de cette version restent à confirmer : RAER peut vous accompagner pour vérifier votre choix.' : 'Les mesures de cette version restent à confirmer. Demandez conseil à RAER pour préparer votre essayage.';
    }
    const rep = [];
    if (fitNumber(profile.height) !== null) rep.push(fitFormat(fitNumber(profile.height)) + ' cm');
    if (fitNumber(profile.weight) !== null) rep.push(fitFormat(fitNumber(profile.weight)) + ' kg');
    fitGet('[data-fit-profile-summary]').textContent = rep.length ? 'Vos repères pour demander conseil à RAER : ' + rep.join(' · ') + '.' : '';
    fitGet('[data-fit-layer-note]').textContent = profile.layers === 'warm' ? 'Avec une couche chaude, vérifiez l’aisance au buste et aux bras. Une taille supérieure n’est pas appliquée automatiquement.' : profile.layers === 'knit' ? 'Gardez votre maille légère pour vérifier le confort, veste fermée et bras avancés.' : profile.layers === 'light' ? 'Vérifiez le confort avec votre T-shirt ou votre chemise, sans oublier les protections prévues pour le modèle.' : 'Pensez à la couche et aux protections que vous porterez pour vérifier l’aisance.';
  };
  const fitRenderNearest = () => {
    const host = fitGet('[data-fit-nearest]'); host.replaceChildren(); host.hidden = true;
    if (!fitState.compared) return;
    const width = fitReadMeasures().halfChest; const rows = fitNearest(); const all = fitRows();
    if (!all.length) return;
    host.hidden = false;
    if (!width) { host.append(fitText('p', 'Ajoutez la largeur de poitrine de votre veste pour repérer les tailles les plus proches. Les longueurs se comparent avec la taille que vous choisissez ci-dessous.')); return; }
    if (!rows.length) { host.append(fitText('strong', 'Cette largeur se situe hors de la plage du tableau.')); host.append(fitText('p', 'Vérifiez la mesure d’aisselle à aisselle, ou demandez conseil à RAER. Aucune taille n’est déduite en dehors du tableau.')); return; }
    host.append(fitText('strong', rows.length === 1 ? 'La plus proche en largeur : ' + rows[0].size : 'Les plus proches en largeur : ' + rows.map(row => row.size).join(' et ')));
    rows.forEach(row => {
      const delta = fitNumber(row.halfChest) - width;
      const variants = fitVariants().filter(variant => fitNormalizeSize(fitLabel(variant)) === fitNormalizeSize(row.size));
      const status = variants.length ? variants.some(variant => variant.available) ? '' : ' Taille épuisée dans cette version.' : ' Taille non proposée dans cette version.';
      host.append(fitText('p', row.size + ' : ' + fitFormat(fitNumber(row.halfChest)) + ' cm, soit ' + (delta > 0 ? '+' : '') + fitFormat(delta) + ' cm par rapport à votre veste.' + status));
    });
    host.append(fitText('p', 'Cette comparaison porte seulement sur la largeur. Vérifiez aussi les longueurs et l’aisance en mouvement.'));
  };
  const fitRenderComparison = () => {
    const host = fitGet('[data-fit-comparison]'); host.replaceChildren(); host.hidden = true;
    if (fitState.step !== 1 || !fitVariant()) return;
    const size = fitNormalizeSize(fitLabel(fitVariant()));
    const row = fitRows().find(item => fitNormalizeSize(item.size) === size);
    if (!row) {
      if (fitRows().length) { host.hidden = false; host.append(fitText('p', 'Les mesures de la taille ' + fitLabel(fitVariant()) + ' ne figurent pas dans ce tableau. Nous ne les déduisons pas des tailles voisines.', 'raer-fit__quiet')); }
      return;
    }
    host.hidden = false;
    const measures = fitState.compared ? fitReadMeasures() : {};
    const comparing = Object.keys(measures).length > 0;
    const table = document.createElement('table'); table.append(fitText('caption', 'Taille ' + row.size + ' · dimensions à plat'));
    const head = document.createElement('thead'); const tr = document.createElement('tr');
    ['Mesure', 'RAER', ...(comparing ? ['Votre veste', 'Écart'] : [])].forEach(text => { const th = fitText('th', text); th.scope = 'col'; tr.append(th); }); head.append(tr); table.append(head);
    const body = document.createElement('tbody');
    fitKeys.filter(([key]) => fitNumber(row[key]) !== null).forEach(([key, label]) => {
      const line = document.createElement('tr'); const th = fitText('th', label); th.scope = 'row'; line.append(th, fitText('td', fitFormat(fitNumber(row[key])) + ' cm'));
      if (comparing) {
        const value = measures[key]; const delta = value === undefined ? null : fitNumber(row[key]) - value;
        line.append(fitText('td', value === undefined ? '—' : fitFormat(value) + ' cm'), fitText('td', delta === null ? '—' : (delta > 0 ? '+' : '') + fitFormat(delta) + ' cm'));
      }
      body.append(line);
    });
    table.append(body); host.append(table);
  };
  const fitUpdateAction = () => {
    const choosing = fitState.answered || fitState.step === 1;
    const variant = fitVariant();
    fitNext.disabled = choosing && !variant?.available;
    fitNext.textContent = !choosing ? 'Voir mon repère →' : variant?.available ? 'Choisir ' + (data.hasOnlyDefaultVariant ? 'cette version' : 'la taille ' + fitLabel(variant)) : 'Choisir une taille';
    fitGet('[data-fit-back]').hidden = fitState.step === 0;
    fitGet('[data-fit-verify]').hidden = fitState.step === 1;
  };
  const fitRenderSizes = () => {
    const host = fitGet('[data-fit-sizes]'); host.replaceChildren();
    const nearest = fitNearest().map(row => fitNormalizeSize(row.size));
    const variants = [...fitVariants()].sort((a, b) => { const ai = fitRank.indexOf(fitNormalizeSize(fitLabel(a))), bi = fitRank.indexOf(fitNormalizeSize(fitLabel(b))); return (ai < 0 ? 99 : ai) - (bi < 0 ? 99 : bi); });
    variants.forEach(variant => {
      const label = fitLabel(variant); const button = document.createElement('button'); button.type = 'button'; button.disabled = !variant.available;
      button.append(fitText('span', label));
      button.setAttribute('aria-pressed', String(String(variant.id) === fitState.variantId));
      button.setAttribute('aria-label', label + (variant.available ? ', ' + fitAvailability : ', épuisé'));
      if (!variant.available) button.append(fitText('small', 'Épuisé'));
      else if (fitState.step === 1 && nearest.includes(fitNormalizeSize(label))) button.append(fitText('small', 'Largeur proche'));
      else if (fitNormalizeSize(label) === fitTarget()) button.append(fitText('small', 'Votre repère'));
      else if (fitPreorder) button.append(fitText('small', 'Précommande'));
      button.addEventListener('click', () => { fitState.variantId = String(variant.id); fitSetError(''); fitRenderSizes(); host.querySelector('[aria-pressed="true"]')?.focus({preventScroll: true}); });
      host.append(button);
    });
    const variant = fitVariant();
    fitGet('[data-fit-availability]').textContent = variant?.available ? variant.title + ' · ' + fitAvailability + ' · ' + variant.price : variants.some(item => item.available) ? 'Choisissez une taille. Le bouton ci-dessous la sélectionne sur la fiche, sans l’ajouter au panier.' : 'Cette version est actuellement épuisée.';
    fitRenderComparison(); fitUpdateAction();
  };
  const fitRenderOptions = () => {
    const host = fitGet('[data-fit-options]'); host.replaceChildren();
    if (fitSizeIndex < 0) return;
    fitOptionNames.forEach((name, index) => {
      if (index === fitSizeIndex) return;
      const values = [...new Set(data.variants.map(variant => variant.options[index]))];
      if (values.length < 2) return;
      const label = fitText('label', name, 'raer-fit__option'); const select = document.createElement('select'); select.setAttribute('aria-label', String(name));
      values.forEach(value => { const option = fitText('option', value); option.value = value; select.append(option); });
      select.value = fitState.options[index] || values[0];
      select.addEventListener('change', () => {
        fitState.options[index] = select.value; fitState.variantId = null;
        if (!fitVariants().length) { const match = data.variants.find(variant => variant.options[index] === select.value); if (match) fitState.options = [...match.options]; }
        fitRenderAll();
        const nextControl = [...host.querySelectorAll('select')].find(control => control.getAttribute('aria-label') === String(name));
        nextControl?.focus({preventScroll: true});
      });
      label.append(select); host.append(label);
    });
  };
  function fitRenderAll() {
    fitGet('[data-fit-question-panel]').hidden = fitState.answered;
    fitGet('[data-fit-result]').hidden = !fitState.answered;
    fitGet('[data-fit-selection]').hidden = !fitState.answered && fitState.step === 0;
    if (fitState.answered) fitRenderResult();
    fitRenderTable(); fitRenderOptions(); fitRenderNearest(); fitRenderSizes();
  }
  function fitGo(step, focus = true) {
    fitState.step = step === 1 ? 1 : 0;
    fitDialog.querySelectorAll('[data-fit-step]').forEach(panel => { panel.hidden = Number(panel.dataset.fitStep) !== fitState.step; });
    fitDialog.querySelectorAll('[data-fit-go]').forEach(button => { if (Number(button.dataset.fitGo) === fitState.step) button.setAttribute('aria-current', 'step'); else button.removeAttribute('aria-current'); });
    fitSetError(''); fitRenderAll(); fitGet('[data-fit-scroll]').scrollTop = 0;
    fitLive.textContent = fitState.step === 1 ? 'Vérification facultative des mesures.' : fitState.answered ? 'Votre premier repère et les tailles proposées.' : 'Quatre questions pour préparer votre choix.';
    if (focus) (fitState.step === 0 && fitState.answered ? fitGet('[data-fit-result-title]') : fitGet('[data-fit-step="' + fitState.step + '"] [data-fit-heading]')).focus({preventScroll: true});
  }
  const fitSubmitQuick = () => {
    if (!fitValidateProfile()) return;
    fitState.answered = true;
    const target = fitTarget();
    const match = fitVariants().find(variant => variant.available && fitNormalizeSize(fitLabel(variant)) === target);
    fitState.variantId = match ? String(match.id) : null;
    fitGo(0);
  };
  fitNext.addEventListener('click', () => {
    if (!fitState.answered && fitState.step === 0) { fitSubmitQuick(); return; }
    const variant = fitVariant();
    if (!variant?.available) { fitSetError('Choisissez une taille disponible pour revenir à la fiche.'); return; }
    chosen = [...variant.options]; updateVariant(true); closeDialog();
    root.querySelector('[data-cart-message]')?.setAttribute('hidden', '');
    root.querySelector('[data-cart-link]')?.setAttribute('hidden', '');
  });
  fitGet('[data-fit-question-panel]').addEventListener('keydown', event => { if (event.key === 'Enter' && event.target.tagName === 'INPUT') { event.preventDefault(); fitSubmitQuick(); } });
  fitDialog.querySelectorAll('[data-fit-go]').forEach(button => button.addEventListener('click', () => fitGo(Number(button.dataset.fitGo))));
  fitGet('[data-fit-check-direct]').addEventListener('click', () => fitGo(1));
  fitGet('[data-fit-verify]').addEventListener('click', () => fitGo(1));
  fitGet('[data-fit-back]').addEventListener('click', () => fitGo(0));
  fitGet('[data-fit-edit]').addEventListener('click', () => { fitState.answered = false; fitState.variantId = null; fitGo(0); });
  fitGet('[data-fit-compare]').addEventListener('click', () => {
    if (!fitValidateMeasures()) return;
    fitState.compared = true; fitRenderNearest(); fitRenderSizes();
    fitLive.textContent = fitNearest().length ? 'Comparaison mise à jour. Tailles les plus proches en largeur : ' + fitNearest().map(row => row.size).join(', ') + '.' : 'Comparaison mise à jour. Consultez les mesures et les indications affichées.';
  });
  fitMeasures.forEach(input => input.addEventListener('input', () => { fitState.compared = false; input.removeAttribute('aria-invalid'); fitSetError(''); fitRenderNearest(); fitRenderComparison(); }));
  fitGet('[data-fit-restart]').addEventListener('click', () => {
    [...fitFields, ...fitMeasures].forEach(input => { input.value = ''; input.removeAttribute('aria-invalid'); });
    fitState.answered = false; fitState.compared = false; fitState.variantId = null; fitState.options = [...chosen];
    fitGet('[data-fit-table-details]').open = false; fitGo(0);
  });
  fitGet('[data-fit-protection-note]').textContent = root.dataset.fitPads === 'true' ? 'Pour un usage moto, faites cet essai avec les protections prévues dans leurs emplacements. Consultez la fiche pour savoir si elles sont fournies.' : 'Si vous portez une protection sous la veste, gardez-la pour vérifier le confort avec votre couche habituelle.';
  root.querySelectorAll('[data-size-guide-open]').forEach(button => button.addEventListener('click', () => {
    fitState.options = [...chosen]; fitState.variantId = null; fitState.answered = false; fitState.compared = false;
    fitGo(0, false);
  }));
  fitGo(0, false);
}

        root.classList.add('is-enhanced');
        updateVariant();
        document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) closeDialog(); });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount());
    else mount();
    document.addEventListener('shopify:section:load', event => mount(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
